import { defineMessages } from "react-intl";
export default defineMessages({
  settings: {
    "id": "settings.settings",
    "defaultMessage": "Settings"
  },
  account: {
    "id": "settings.account",
    "defaultMessage": "Account"
  },
  accountDescription: {
    "id": "settings.accountDescription",
    "defaultMessage": "Profile, password change"
  },
  profile: {
    "id": "settings.profile",
    "defaultMessage": "Profile"
  },
  display: {
    "id": "settings.display",
    "defaultMessage": "Display"
  },
  displayDescription: {
    "id": "settings.displayDescription",
    "defaultMessage": "Customize the general appearance"
  },
  units: {
    "id": "settings.units",
    "defaultMessage": "Units"
  },
  unitsDescription: {
    "id": "settings.unitsDescription",
    "defaultMessage": "Measurement units displayed within the application"
  },
  language: {
    "id": "settings.language",
    "defaultMessage": "Language"
  },
  languageDescription: {
    "id": "settings.languageDescription",
    "defaultMessage": "Preferred language"
  },
  contact: {
    "id": "settings.contact",
    "defaultMessage": "Contact"
  },
  contactDescription: {
    "id": "settings.contactDescription",
    "defaultMessage": "Contact the developer"
  },
  about: {
    "id": "settings.about",
    "defaultMessage": "About"
  },
  aboutDescription: {
    "id": "settings.aboutDescription",
    "defaultMessage": "License agreement, privacy policy"
  },
  privacyPolicy: {
    "id": "settings.privacyPolicy",
    "defaultMessage": "Privacy policy"
  },
  termsOfService: {
    "id": "settings.termsOfService",
    "defaultMessage": "Terms of service"
  },
  updateYourProfile: {
    "id": "settings.updateYourProfile",
    "defaultMessage": "Update your profile"
  },
  update: {
    "id": "settings.update",
    "defaultMessage": "Update"
  },
  accountIntro: {
    "id": "settings.accountIntro",
    "defaultMessage": "Data concerns your account:"
  },
  oldPassword: {
    "id": "settings.oldPassword",
    "defaultMessage": "Old password"
  },
  newPassword: {
    "id": "settings.newPassword",
    "defaultMessage": "New password"
  },
  newPasswordAgain: {
    "id": "settings.newPasswordAgain",
    "defaultMessage": "New password again"
  },
  passwordChange: {
    "id": "settings.passwordChange",
    "defaultMessage": "Password change"
  },
  changePassword: {
    "id": "settings.changePassword",
    "defaultMessage": "Change password"
  },
  addons: {
    "id": "settings.addons",
    "defaultMessage": "Add-ons"
  },
  addonsDescription: {
    "id": "settings.addonsDescription",
    "defaultMessage": "Enhance the experience by connecting additional services"
  },
  premium: {
    "id": "settings.premium",
    "defaultMessage": "Premium"
  },
  premiumDescription: {
    "id": "settings.premiumDescription",
    "defaultMessage": "Unlock premium features"
  },
  light: {
    "id": "settings.light",
    "defaultMessage": "Light theme"
  },
  dark: {
    "id": "settings.dark",
    "defaultMessage": "Dark theme"
  },
  systemTheme: {
    "id": "settings.systemTheme",
    "defaultMessage": "System theme"
  },
  english: {
    "id": "settings.english",
    "defaultMessage": "English"
  },
  french: {
    "id": "settings.french",
    "defaultMessage": "French"
  },
  german: {
    "id": "settings.german",
    "defaultMessage": "German"
  },
  spanish: {
    "id": "settings.spanish",
    "defaultMessage": "Spanish"
  },
  italian: {
    "id": "settings.italian",
    "defaultMessage": "Italian"
  },
  polish: {
    "id": "settings.polish",
    "defaultMessage": "Polish"
  },
  hungarian: {
    "id": "settings.hungarian",
    "defaultMessage": "Hungarian"
  },
  swedish: {
    "id": "settings.swedish",
    "defaultMessage": "Swedish"
  },
  czech: {
    "id": "settings.czech",
    "defaultMessage": "Czech"
  },
  dutch: {
    "id": "settings.dutch",
    "defaultMessage": "Dutch"
  },
  danish: {
    "id": "settings.danish",
    "defaultMessage": "Danish"
  },
  serbian: {
    "id": "settings.serbian",
    "defaultMessage": "Serbian"
  },
  croatian: {
    "id": "settings.croatian",
    "defaultMessage": "Croatian"
  },
  norwegian: {
    "id": "settings.norwegian",
    "defaultMessage": "Norwegian"
  },
  portuguese: {
    "id": "settings.portuguese",
    "defaultMessage": "Portuguese"
  },
  slovak: {
    "id": "settings.slovak",
    "defaultMessage": "Slovak"
  },
  bulgarian: {
    "id": "settings.bulgarian",
    "defaultMessage": "Bulgarian"
  },
  russian: {
    "id": "settings.russian",
    "defaultMessage": "Russian"
  },
  ukrainian: {
    "id": "settings.ukrainian",
    "defaultMessage": "Ukrainian"
  },
  japanese: {
    "id": "settings.japanese",
    "defaultMessage": "Japanese"
  },
  korean: {
    "id": "settings.korean",
    "defaultMessage": "Korean"
  },
  gestures: {
    "id": "settings.gestures",
    "defaultMessage": "Gestures"
  },
  chartGestures: {
    "id": "settings.chartGestures",
    "defaultMessage": "Gestures on charts"
  },
  chartGesturesDescription: {
    "id": "settings.chartGesturesDescription",
    "defaultMessage": "Swiping on charts changes the time period, pinching charts changes time scale"
  },
  dateAndTime: {
    "id": "settings.dateAndTime",
    "defaultMessage": "Date and time"
  }
});